export default __webpack_public_path__ + "static/media/commission-aviation-regulation.4b5f4937.png";